import { atom } from "jotai";

export interface DocumentHistoryEntry {
  documentId: string;
  documentTitle: string;
  pageNo: number;
  createdAt: number; // epoch ms
}

export interface GroupedDocumentHistory {
  today: DocumentHistoryEntry[];
  thisWeek: DocumentHistoryEntry[];
  before: DocumentHistoryEntry[];
}

export const documentHistoryAtom = atom<DocumentHistoryEntry[]>([]);
